import { useState } from "react";
import FullScreenModal from "../../../components/FullScreenModal";
import clsx from "clsx";
import { useMetasearchStatus } from "../hooks";
import { FeedStatus, BOOKING_ENGINE_OPTIONS } from "../types";
import { ConfigContent } from "./ConfigContent";
import { DiagnosticsContent } from "./DiagnosticsContent";

type DetailTab = "config" | "diagnostics";

const DETAIL_TABS: { key: DetailTab; label: string }[] = [
  { key: "config", label: "Configuration" },
  { key: "diagnostics", label: "Diagnostics" },
];

export function HotelDetailModal({
  isOpen,
  configId,
  onClose,
}: {
  isOpen: boolean;
  configId: string;
  onClose: () => void;
}) {
  const [activeTab, setActiveTab] = useState<DetailTab>("config");
  const { data: allStatus } = useMetasearchStatus();
  const config: FeedStatus | undefined = allStatus?.find(
    (s: FeedStatus) => s.configId === configId
  );

  const engineLabel =
    BOOKING_ENGINE_OPTIONS.find((o) => o.value === config?.bookingEngineType)
      ?.label || config?.bookingEngineType;

  return (
    <FullScreenModal isOpen={isOpen} onClose={onClose}>
      <div className="p-4 md:p-6 h-full overflow-auto bg-neutral-200">
        <div className="max-w-[1252px] mx-auto">
          <div className="bg-white rounded-lg shadow-sm border border-[#E9E9EB] p-5 mb-5">
            <div className="flex items-center justify-between">
              <div>
                <h2 className="text-xl font-semibold text-gray-900">
                  {config?.hotelName || "Hotel Details"}
                </h2>
                {config && (
                  <div className="flex items-center gap-3 mt-2">
                    <span className="text-sm text-gray-500">{engineLabel}</span>
                    <span className="text-xs font-mono text-gray-700 bg-gray-100 border border-gray-300 px-1.5 py-0.5 rounded">
                      {config.googlePropertyId}
                    </span>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="flex items-center gap-1 mb-5 bg-white rounded-lg p-1 shadow-sm border border-[#E9E9EB] w-fit">
            {DETAIL_TABS.map((tab) => (
              <button
                key={tab.key}
                onClick={() => setActiveTab(tab.key)}
                className={clsx(
                  "px-4 py-2 text-sm font-medium rounded-md transition-colors",
                  activeTab === tab.key
                    ? "bg-primary text-white"
                    : "text-gray-600 hover:bg-gray-100"
                )}
              >
                {tab.label}
              </button>
            ))}
          </div>

          {activeTab === "config" && <ConfigContent configId={configId} onClose={onClose} />}
          {activeTab === "diagnostics" && (
            <DiagnosticsContent
              googlePropertyId={config?.googlePropertyId}
            />
          )}
        </div>
      </div>
    </FullScreenModal>
  );
}
